var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextcolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 23.3333C3.5 22.689 4.02233 22.1667 4.66667 22.1667H23.3333C23.9777 22.1667 24.5 22.689 24.5 23.3333C24.5 23.9777 23.9777 24.5 23.3333 24.5H4.66667C4.02234 24.5 3.5 23.9777 3.5 23.3333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0787 16.3333H9.92133L8.34801 20.2666C8.17084 20.7096 7.74186 21 7.26482 21C6.43947 21 5.8751 20.1664 6.18163 19.4001L12.54 4.23338C12.7172 3.79044 13.1461 3.5 13.6232 3.5H14.3768C14.8539 3.5 15.2828 3.79044 15.46 4.23338L21.8184 19.4001C22.1249 20.1664 21.5605 21 20.7352 21C20.2581 21 19.8292 20.7096 19.652 20.2666L18.0787 16.3333ZM17.1453 14L14 6.86583L10.8547 14H17.1453Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextcolor);
export default __webpack_public_path__ + "static/media/textcolor.e2230d9f33943953f3b0fb0d9c15b1a1.svg";
export { ForwardRef as ReactComponent };